// Update ProfileRouter.js to limit logging and pass location state properly
import React, { useContext } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ArtistProfile from './ArtistDashboard/Profile';
import CrewProfile from './CrewDashboard/Profile';
import ManagerProfile from './ManagerDashboard/Profile';
import VendorProfile from './VendorDashboard/Profile';
import StaffProfile from './StaffDashboard/Profile';
import OrganizationProfile from './OrganizationDashboard/Profile';
import AdminProfile from './AdminDashboard/Profile';
import UserContext from '../context/UserContext';
import PublicProfile from './PublicProfile';

const ProfileRouter = ({ username, modalState }) => {
  // If username wasn't passed via props, get it from params
  const params = useParams();
  const location = useLocation();
  const profileUsername = username || params.username;
  const { userData: currentUser } = useContext(UserContext);

  // If user is not logged in, show public profile
  if (!currentUser) {
    return <PublicProfile username={profileUsername} />;
  }

  const renderProfile = () => {
    // Determine if this is the user's own profile
    const isOwnProfile = currentUser.userName === profileUsername;
    
    // We only need to log this when debugging, not in production
    // To reduce unnecessary console spam, comment these out for production
    /*
    console.log('Profile router: username =', profileUsername);
    console.log('Current user username =', currentUser.userName);
    console.log('isOwnProfile =', isOwnProfile);
    */
    
    // Common props to pass to all profile type components
    const profileProps = {
      username: profileUsername,
      currentUser,
      isOwnProfile,
      // Pass location state to handle modal properly
      modalState: modalState || location.state
    };
    
    switch (currentUser.userType) {
      case 'Artist':
        return <ManagerProfile {...profileProps} />;
      case 'Crew':
        return <ManagerProfile {...profileProps} />;
      case 'Manager':
        return <ManagerProfile {...profileProps} />;
      case 'Vendor':
        return <ManagerProfile {...profileProps} />;
      case 'Staff':
        return <ManagerProfile {...profileProps} />;
      case 'Organization':
        return <ManagerProfile {...profileProps} />;
      case 'Admin':
        return <AdminProfile {...profileProps} />;
      default:
        return <div>User type not recognized: {currentUser.userType}</div>;
    }
  };

  return renderProfile();
};

export default ProfileRouter;